import { ActorEnumType, ListActorsRequestType } from "../network/schema";

export const ACTOR_FILTER_OPTIONS = ["saved", "custom", "default"] as const;
export type ActorFilterOption = (typeof ACTOR_FILTER_OPTIONS)[number];

export const ACTOR_TAG_FILTERS = {
  default: ["stock", "captions_ingest"],
  custom: ["uploaded", "twin", "prompt"],
} satisfies Partial<Record<ActorFilterOption, ActorEnumType[]>>;

export function getTypesForTag(tag: string): ActorEnumType[] | undefined {
  if (tag === "default" || tag === "custom") {
    return ACTOR_TAG_FILTERS[tag];
  }

  return undefined;
}

export function getFilterParamsForTag(tag: string): Pick<ListActorsRequestType, "filters"> {
  if (tag === "default" || tag === "custom") {
    return { filters: { types: ACTOR_TAG_FILTERS[tag] } };
  }

  return { filters: undefined };
}

export function getAllPossibleActorQueryParams(): Pick<ListActorsRequestType, "filters">[] {
  return [getFilterParamsForTag("")].concat(
    Object.entries(ACTOR_TAG_FILTERS).map(([_, types]) => ({
      filters: { types },
    }))
  );
}
